import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import repository from './repository';
import Quality from '@/componentes/quality';
import ComboStatus from '@/modules/admin/combos/status';

import Template from '@/modules/admin/template';

export function Group() {

  const dataInitial = {
    client: 0,
    status: true
  };

  const [list, setList] = useState([]);
  const [filters, setFilters] = useState(dataInitial);

  useEffect(() => {
    handleList();
  }, []);

  const handleList = (e) => {

    new Promise((resolve, reject) => {

      if (e !== undefined) {

        var params = {
          ...filters,
          [e.target.getAttribute('name')]: e.target.value
        };

        setFilters(params);

        resolve(params);
      }
      else {
        resolve({ ...filters });
      }

    }).then((result) => {

      repository.getList(result, (response) => {
        setList(response.data);
      });
    });
  };

  return (
    <>
      <Template title="Grupos">
        <div className="table_grid_filter">
          <div class="row">
            <div className="col-sm-3">Status</div>
          </div>
          <div class="row">
            <div className="col-sm-3">
              <ComboStatus handleList={handleList} />
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-striped table_grid">
            <thead>
              <tr>
                <th>Cliente</th>
                <th>Titulo</th>
                <th>Status</th>
                <th className="option">
                  <Link to="/admin/groups/form">
                    <button>Novo</button>
                  </Link>
                </th>
              </tr>
            </thead>
            <tbody>
              {list &&
                list.map((obj, index) => (
                  <tr key={index}>
                    <td>{obj.clientTitle}</td>
                    <td>{obj.title}</td>
                    <td><Quality value={obj.status} /></td>
                    <td className="option">
                      <Link to={`/admin/groups/form/${obj.id}`}>
                        <button>Editar</button>
                      </Link>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </Template>
    </>
  )
}

export default Group;